export default __webpack_public_path__ + "static/media/bosyuu2_frame.20019278.svg";